import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/seo-content";

export default function ArticleGrid() {
  return (
    <section className="relative py-16 md:py-24 bg-foreground-950">
      <div className="px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-14">
          <div className="lg:w-1/3">
            <span className="inline-flex items-center px-4 py-1.5 text-xs font-medium rounded-full border border-white/20 text-white/70 whitespace-nowrap">
              Read Guides
            </span>
          </div>
          <div className="lg:w-2/3">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-tight">
              Pandabuy Spreadsheet
              <br />
              <span className="text-white/60">SEO Hub</span>
            </h2>
          </div>
        </div>

        <div
          className="flex gap-5 overflow-x-auto pb-2"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-[320px] bg-background-50 rounded-lg overflow-hidden group hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-primary-600 mb-2">{article.category}</span>
                <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <span className="inline-block mt-3 text-sm font-medium text-primary-600">
                  Read More &rarr;
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}